export function getPath(target: EventTarget | Element, max: number = 20): Element[] {
  if (target == null || !(target instanceof Element)) return [];
  if (target.parentElement == null) return [target];

  let arr = [target];
  let parentElement = target.parentElement;

  while (parentElement != null && arr.length < max) {
    if (parentElement instanceof Element) {
      arr.push(parentElement);
      parentElement = parentElement.parentElement;
    } else {
      parentElement = null;
    }
  }
  return arr;
}
